<!-- TODO: Update width once merged with "size" PR -->
<app-launch-field-container 
[basespaceFormControl]="formControl"
width="100%"
>
    <div class="resource-chooser__buttons">
        <rad-button 
            (click)="openResourceChooser()"
            [attr.disabled]="formControl.disabled"
            class="rad-theme--light resource-chooser__select-button" 
            variant="secondary">
            Select {{resourceButtonTitle}}...
        </rad-button>

        <rad-button 
            *ngIf="formControl.displayFields && (selectedItems$ | async)?.length > 0"
            (click)="openEditAllModal()"
            class="rad-theme--light edit-all-button"
            variant="tertiary"
            icon-name-before="edit">
            Edit all
        </rad-button>
    </div>

    <div class="resource-chip-container" *ngIf="!formControl.disabled && !formControl.displayFields">
        <ng-container *ngIf="selectedItems$ | async as selectedItems">
            <app-resource-chip 
                *ngFor="let item of selectedItems; trackBy: trackByResourceId"
                [resourceName]="getSelectedItemName(item)"
                [resourceUrl]="getResourceUrl(item)"
                (chipRemoved)="removeSearchResult(item)"
            >
            </app-resource-chip>
        </ng-container>
    </div>

    <ng-container *ngIf="selectedItems$ | async as selectedItems">
        <div 
        *ngIf="
            !formControl.disabled && 
            formControl.displayFields &&
            selectedItems.length > 0
        " 
        class="display-fields-container">
            <app-launch-table
                [tableRowsControl]="formControl.displayFieldsTabularFieldSetControl"
                [fields]="formControl.displayFields"
                [fieldCells]="formControl.fieldCells"
                [resourceChooserControl]="formControl"
                [selectedItems$]="selectedItems$"
            ></app-launch-table>

        </div>
    </ng-container>
    
</app-launch-field-container>